import { render } from "./LinkProductsToComboDiscountGroupModal.html?vue&type=template&id=12f47eeb&scoped=true"
import script from "./LinkProductsToComboDiscountGroupModal.js?vue&type=script&lang=js"
export * from "./LinkProductsToComboDiscountGroupModal.js?vue&type=script&lang=js"

import "./LinkProductsToComboDiscountGroupModal.css?vue&type=style&index=0&id=12f47eeb&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f47eeb"]])

export default __exports__